import { Http, PageQuery } from '@mygpt/app/http';

export interface QueryMessageListParams extends PageQuery {
  aiId: string;
  startTime: string;
  endTime: string;
  source?: string;
  min_score?: number;
  max_score?: number;
  session_id?: string;
  user_identifier?: string;
  /** 来源页面 URL 模糊匹配（大小写不敏感子串），用于区分同一 Bot 嵌入的不同站点 */
  url_keyword?: string;
}

/**
 * 获取历史会话列表
 * @param params
 * @returns
 */
export const queryMessageList = (params: QueryMessageListParams) => {
  const {
    aiId,
    endTime,
    max_score,
    min_score,
    page,
    session_id,
    size,
    source,
    startTime,
    user_identifier,
    url_keyword,
  } = params;
  const sourceQuery = source ? `&source=${source}` : '';
  const minScoreQuery = typeof min_score === 'number' ? `&min_score=${min_score}` : '';
  const maxScoreQuery = typeof max_score === 'number' ? `&max_score=${max_score}` : '';
  const sessionId = session_id ? `&session_id=${session_id}` : '';
  const userIdentifier = user_identifier ? `&user_identifier=${user_identifier}` : '';
  // URL 关键词可能包含 / ? & 等字符，必须编码
  const urlKeyword = url_keyword ? `&url_keyword=${encodeURIComponent(url_keyword)}` : '';
  const { post } = Http.use();
  return post(
    `/questions/${aiId}/session.list?start_time=${startTime}&end_time=${endTime}&page=${page}&size=${size}${sourceQuery}${minScoreQuery}${maxScoreQuery}${sessionId}${userIdentifier}${urlKeyword}&order_by=-updated_at`
  );
};

export interface QueryMessageDetailParams extends PageQuery {
  aiId: string;
  sessionId: string;
  endTime: string;
}

/**
 * 获取会话的消息列表
 * @param params
 * @returns
 */
export const queryMessageDetail = (params: QueryMessageDetailParams) => {
  const { aiId, endTime, page, sessionId, size } = params;
  const { get } = Http.use();
  return get(
    `/questions/${aiId}/session.messages?session_id=${sessionId}&end_time=${endTime}&page=${page}&size=${size}&order_by=+created_at`
  );
};
